import React, { FunctionComponent } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";

const ErrorFallback: FunctionComponent = (): JSX.Element => {
	return (
		<Flex justifyContent={"space-between"}>
			<Box></Box>
			<Box
				display={"inline-block"}
				alignItems={"center"}
				borderRadius="md"
				p={3}
				px={6}
				backgroundColor="neutrals.20"
				color="accent.orange.500"
				my={3}
			>
				<Text fontFamily="Poppins" fontSize="sm" fontWeight="medium" role="heading" textAlign={"center"}>
					Error loading Courses module. Please refresh the page and try again.
				</Text>
			</Box>
			<Box></Box>
		</Flex>
	);
};

export default ErrorFallback;
